import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LangContext } from '../../contexts/langContext';
import { SocialContext } from '../../contexts/socialContext';
import { StateContext } from '../../contexts/stateContext';
import { default_design } from '../../static/default_design';
import { UncertainContext } from '../../contexts/uncertainContext';
import { UncertainSourceSelect } from '../Edu/Uncertain';
import { NarrativesList } from './NarrativesList';
import { WithVersion } from './VersionToggler';
import { Astro } from '../Edu/Astro';
import { Jyotish } from '../Edu/Jyotish';


export function Guide({
  avatar = {},
  person = default_design,
  narrative,
  // activeLink,
  scrollToSection
}) {

  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) };
  const uncertain = useContext(UncertainContext);
  const $ = context.$;
  const $ui = context.$ui;

  const [activeLink, setActiveLink] = useState('calculate');
  const [guideShown, setGuideShown] = useState(true);
  const guideRef = useRef(null);

  const [scrollTo, setScrollTo] = useState(-1);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (guideRef.current && !guideRef.current.contains(event.target)) {
        setGuideShown(false);
      }
    };
    // document.addEventListener('mouseover', handleClickOutside);
    return () => {
      // document.removeEventListener('mouseover', handleClickOutside);
    };
  }, [guideRef]);



  useEffect(() => {
    const probeY = () => window.innerHeight * 0.5;

    const updateActive = () => {
      const y = probeY();
      let bestId = '';
      let bestDist = Infinity;

      document.querySelectorAll('.x_edu_content0').forEach((el) => {
        if (!el.id) return;
        const rect = el.getBoundingClientRect();
        if (rect.height <= 0) return;
        const dist = y < rect.top ? rect.top - y : y > rect.bottom ? y - rect.bottom : 0;
        if (dist < bestDist) {
          bestDist = dist;
          bestId = el.id;
        }
      });

      if (bestId) setActiveLink(bestId);
    };

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        updateActive();
        ticking = false;
      });
    };

    updateActive();
    window.addEventListener('scroll', onScroll, true);
    window.addEventListener('resize', onScroll);

    const sections = document.querySelectorAll('.x_edu_content0');
    const targetSection = sections[scrollTo];
    if (targetSection) {
      targetSection.scrollIntoView({
        behavior: 'smooth',
      });
    }

    return () => {
      window.removeEventListener('scroll', onScroll, true);
      window.removeEventListener('resize', onScroll);
    };
  }, [narrative]);


  const navigate = useNavigate();
  const location = useLocation();
  const handleAstroClick = (what = 'astro') => {
    let newPath = location.pathname.split('/study')[0];
    newPath = newPath.slice(-1) === '/' ? newPath + `study/${what}` : newPath + `/study/${what}`
    const queryParams = location.search ? location.search : '';
    navigate(`${newPath}${queryParams}`);
  };





  return (
    <>

      <div className="x_guide00">

        {/* <div className="x_gude_z" /> */}

          <div className="x_guide0" ref={guideRef}>



            {!guideShown && <div className="x_guide_trigger0"
              onClick={() => setGuideShown(!guideShown)}
            >
              <div className="x_guide_trigger">
                <div className="t_icon t_icon--20">
                  <div>menu</div>
                </div>
              </div>
            </div>}


            <div className={guideShown ? "x_guide active" : "x_guide"}>

              {Boolean(context.me) && <div className="x_guide_narratives">
                <UncertainSourceSelect variant="segmented" />
                {(!uncertain?.available || uncertain.main !== 'uncertain') && (
                  <NarrativesList variant="select" />
                )}
              </div>}

              <div className="x_theory_1 active"
              >
                {/* <div className="x_theo_h1">
                <div>Fundamentals</div>
              </div> */}

                <div className="x_theo_ul">

                {Boolean(narrative) && Boolean(narrative.pages) &&
                  narrative.pages
                    .filter(one => $('title', one))
                    .filter(one => !one['utility'])
                    .filter(one => !one.beta || context.state.version === 'β')
                    .map(one => {
                  let oneId = one.id;
                    return (<div key={`nav_${oneId}_${1}`}>

                      {one['component'] && $('title', one) &&
                        <div className="x_theo_li active"

                          onClick={() => oneId ? scrollToSection(oneId) : void (0)}
                        >
                          {$('title', one)}

                          {activeLink === oneId && <div className="x_theo_active">
                            {/* <div className="t_icon-2 t_icon--28">
                            <div>chevron_right</div>
                          </div> */}
                          </div>}

                        </div>}

                      {!one['component'] &&
                        <div className="x_theo_li "
                          onClick={() => oneId ? scrollToSection(oneId) : void (0)}
                        >
                          {$('title', one)}

                          {activeLink === oneId && <div className="x_theo_active">
                            {/* <div className="t_icon-2 t_icon--28">
                            <div>chevron_right</div>
                          </div> */}
                          </div>}

                        </div>}

                    </div>)
                  })}



                  {/*
                <div className="x_theo_li blocked">
                  <div>Gates, Channels, Circuits</div>
                </div>
                <div className="x_theo_li blocked">
                  <div>Personality &amp;&nbsp;Body</div>
                </div>
                <div className="x_theo_li blocked">
                  <div>Mind / brain modality</div>
                </div>
                <div className="x_theo_li blocked">
                  <div>Ideal environment &amp;&nbsp;Nutrition</div>
                  </div> */}
                  <br/>
                  <br/>
                                  {Boolean(avatar.dob)
                                    && <WithVersion>
                                      <div className=" mobile_vh_no">
                                        {context.state.astroShown
                                          && Boolean(avatar.astro)
                                          && <Astro
                                            avatar={avatar}
                                            handleClick={handleAstroClick}
                                          />}
                                          <br/>
                                        {context.state.jyotishShown
                                          && <Jyotish
                                            avatar={avatar}
                                            handleClick={handleAstroClick}
                                          />}
                                      </div>
                                  </WithVersion>}
                
                </div>

              </div>

              {/* <div className="x_theory_1">
              <div className="x_theo_h1">
                <div>Live your design</div>
              </div>
              <div className="x_theo_ul">
                <div className="x_theo_li">
                  <div>Hear your authority</div>
                </div>
                <div className="x_theo_li">
                  <div>realize your hi-level life narrative (incarnarion cross)</div>
                </div>
                <div className="x_theo_li">
                  <div>Watch your definition</div>
                </div>
                <div className="x_theo_li">
                  <div>Planetary transits</div>
                </div>
              </div>
            </div> */}

              {/* <div className="x_theory_1">
              <div className="x_theo_h1">
                <div>Interaction &amp;&nbsp;Conditioning</div>
              </div>
              <div className="x_theo_ul">
                <div className="x_theo_li">
                  <div>
                    <div>Parental programs</div>
                  </div>
                </div>
                <div className="x_theo_li">
                  <div>Romantic relationships</div>
                </div>
                <div className="x_theo_li">
                  <div>Friendly relationships</div>
                </div>
                <div className="x_theo_li">
                  <div>Work relationships</div>
                </div>
              </div>
            </div> */}




            </div>



          </div>








      </div>
    </>
  )
}